import { RowTable } from '../../../../func/components/Table';
import { LandInfoProprs } from '../../data';

interface Props {
  landInfo: LandInfoProprs;
}

const LandMapping = {
  area: '토지면적',
  zoning_backup: '용도지역',
  category: '지목',
  usestatus: '이용상황',
  height: '고저',
  roadsurface: '도로',
  far_rate: '용적률',
  bcr_rate: '건폐율',
};

const transformData = (data: Record<string, any>) => {
  return Object.entries(LandMapping).map(([key, label]) => ({
    key: label, // 한글 키 (예: '토지면적')
    value:
      label === '토지면적'
        ? `${data[key]}m² (${Number(data['pyeong']).toFixed(2)}평)`
        : 
        (
          ['용적률', '건폐율'].includes(label)
          ? `${data[key]}%`
          : (data[key] ?? '-')
        ),
  }));
};

const LandInfo = ({ landInfo }: Props) => {
  return <RowTable data={transformData(landInfo)} titleWidth={120} />;
};
export default LandInfo;
